import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgBellRinging(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 5.95a2 2 0 1 1 4 0v.626a5.602 5.602 0 0 1 3.565 4.6L18 15H6l.435-3.824A5.602 5.602 0 0 1 10 6.576v-.627Zm3 0v.347a5.622 5.622 0 0 0-2 0V5.95a1 1 0 1 1 2 0ZM5.981 16A1 1 0 0 0 6 18h12a1 1 0 0 0 .018-2H5.981ZM12 21a3.001 3.001 0 0 1-2.83-2h5.66A3.001 3.001 0 0 1 12 21ZM5.526 5.44a5.5 5.5 0 0 0-2.255 7.445.5.5 0 1 1-.881.472 6.5 6.5 0 0 1 2.664-8.798.5.5 0 1 1 .472.882Zm13.069 0a5.5 5.5 0 0 1 2.255 7.445.5.5 0 1 0 .881.472 6.5 6.5 0 0 0-2.664-8.798.5.5 0 1 0-.472.882Zm-13.56 6.501A3.5 3.5 0 0 1 6.47 7.204a.5.5 0 0 0-.472-.882 4.5 4.5 0 0 0-1.845 6.091.5.5 0 0 0 .882-.472ZM17.65 7.204a3.5 3.5 0 0 1 1.435 4.737.5.5 0 0 0 .882.472 4.5 4.5 0 0 0-1.845-6.09.5.5 0 1 0-.472.881Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellRinging);

var BellRingingSolid = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { BellRingingSolid as default };
